import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LoginForm } from 'features/AuthByEmail';
import { AuthenticationContainer } from 'entities/Authentication';
import { useUserAuthData } from 'entities/User';
import { getRouteMain, getSignUp } from 'shared/consts';
import { Flex, Typography } from 'shared/_ui';
import { clearIngressPath } from 'shared/lib/ingressPath';

import styles from './styles.module.scss';
import { LanguageSwitch } from 'features/SwitchLanguage';
import { AuthByTelegram } from 'features/AuthByTelegram';
import { getTelegramLoginBotUsername } from 'shared/consts/telegram';

export const LoginPage: React.FC = () => {
  const authData = useUserAuthData();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const telegramBotUsername = getTelegramLoginBotUsername();
  // Это должно решаться на уровне routes
  React.useEffect(() => {
    clearIngressPath();
    if (authData) navigate(getRouteMain(pathname));
  }, [authData]);

  return (
    <AuthenticationContainer
      layoutControls={<LanguageSwitch />}
      title={t('authentication.login.title')}
      hint={
        <div className={styles.hint}>
          <Flex spacing={8}>
            <Typography.Text type="secondary">
              {t('authentication.login.noAccountYet')}
            </Typography.Text>
            <Typography.Link type="primary">
              <Link to={getSignUp(pathname)}>
                {t('authentication.login.register')}
              </Link>
            </Typography.Link>
          </Flex>
        </div>
      }
    >
      <LoginForm
        authProviders={() => telegramBotUsername
          ? <AuthByTelegram botName={telegramBotUsername} />
          : <Typography.Text type="secondary">{t('paymentReturn.telegramLoginUnavailable')}</Typography.Text>}
      />
    </AuthenticationContainer>
  );
};
